<!--参会人弹框-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    class="attendees-dialog"
    width="400px"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="dialogRules"
      class="form"
      label-position="right"
      label-width="110px"
    >
      <el-form-item prop="name" label="姓名:">
        <el-input v-model="form.name" placeholder class="input"/>
      </el-form-item>
      <el-form-item prop="phone" label="手机号码:">
        <el-input v-model="form.phone" placeholder class="input"/>
      </el-form-item>
      <el-form-item prop="idCardNumber" label="身份证号码:">
        <el-input
          v-model="form.idCardNumber"
          placeholder
          class="input"
        />
      </el-form-item>
      <el-form-item label="参会人照片:">
        <img
          v-if="photo"
          :src="photo"
          class="image"
          @click="$refs.avatar.click()"
        >
        <input
          ref="avatar"
          type="file"
          accept="image/*"
          hidden
          @change="changeAvatar"
        >
        <div v-if="!photo" class="upload" @click="$refs.avatar.click()">
          <i class="el-icon-plus"/>
        </div>
      </el-form-item>
      <div class="remark">
        注：<span class="flag"
        >填写身份证号后可刷身份证通过闸机进入方阵智慧招聘大厅</span
        >
      </div>
    </el-form>
    <span slot="footer">
      <div class="buttons">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          :loading="isLoading"
          type="primary"
          class="blue-bg"
          size="small"
          @click="toSure"
        >保存</el-button
        >
      </div>
    </span>
  </el-dialog>
</template>
<script type="text/ecmascript-6">
import { validatorCard, compress } from '@/assets/js/common'
import { validatePhone } from '@/assets/js/enterprise/index'
import $upload from '@/assets/js/enterprise/upload'

export default {
  props: {
    // 简历人物名字
    title: {
      type: String,
      default() {
        return ''
      }
    },
    photo: {
      type: String,
      default() {
        return null
      }
    },
    dialogForm: {
      type: Object,
      default() {
        return {}
      }
    },
    attendeesDialogShow: {
      type: Boolean,
      default() {
        return false
      }
    },
    from: {
      type: String,
      default() {
        return '1'
      }
    }
  },
  data() {
    let IDCard = (rule, value, cb) => {
      if (value) {
        if (validatorCard(value)) {
          cb()
        } else {
          cb(new Error('身份证格式不正确'))
        }
      } else {
        cb()
      }
    }
    return {
      dialogVisible: false,
      photoFile: null,
      photoChange: false,
      isLoading: false,
      form: {},
      dialogRules: {
        name: {
          required: true,
          message: '请输入参会人姓名',
          trigger: 'blur'
        },
        phone: [
          {
            required: true,
            message: '请输入参会人员手机号码',
            trigger: 'blur'
          },
          { validator: validatePhone, trigger: ['blur'] }
        ],
        idCardNumber: [
          {
            required: true,
            message: '请输入参会人员身份证号码',
            trigger: 'blur'
          },
          { validator: IDCard, trigger: ['blur'] }
        ]
      }
    }
  },
  watch: {
    attendeesDialogShow(v) {
      this.dialogVisible = v
    },
    dialogForm(v) {
      this.form = { ...v }
    }
  },

  methods: {
    changeAvatar(event) {
      // 上传图片大小控制在10M
      this.photoFile = event.target.files[0]
      if (this.photoFile.size > 10 * 1024 * 1024) {
        this.$message.error('上传的文件不能够超过10M')
        return
      }
      this.$emit('changePhoto', window.URL.createObjectURL(this.photoFile))
      // 清空避免上传同一张出现了无法触发change导致上传失败的情况。
      event.target.value = ''
    },
    closeDialog() {
      this.$refs.form.resetFields()
      this.isLoading = false
      this.form = { ...this.dialogForm }
      this.$emit('close')
    },
    // from 1:参会人 2：招聘会参会人  type:1 添加，2：修改
    oprateAttendees(from, type) {
      switch (from) {
        case 1:
          switch (type) {
            case 1:
              this.$api.addAttendees(
                this.form,
                () => {
                  this.$message.success('参会人员信息新增成功！')
                  this.$emit('updateAttendees')
                  this.photoFile = null
                },
                () => {
                  this.isLoading = false
                }
              )
              break
            case 2:
              this.$api.modifyAttendees(
                this.form.id,
                this.form,
                () => {
                  this.$message.success('参会人员信息更新成功！')
                  this.$emit('updateAttendees')
                },
                () => {
                  this.isLoading = false
                }
              )
              break
          }
          break
        case 2:
          this.$api.addActivityEnterprisePerson(
            this.$route.params.id,
            this.form,
            () => {
              this.$message.success('参会联系人添加成功！')
              this.dialogVisible = false
              this.$emit('updateAttendees')
            },
            () => {
              this.isLoading = false
            }
          )
          break
      }
    },
    toUploadPic(from, type) {
      compress(this.photoFile, { quality: 0.8 }, (zipFile) => {
        $upload('enterpriseImage', zipFile, (url) => {
          this.form.photo = url
          this.oprateAttendees(from, type)
        })
      })
    },
    toSure() {
      // 1,企业常用参会人
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.isLoading = true
          switch (this.from) {
            case '1':
              if (this.form.id) {
                if (!this.photoFile) {
                  this.oprateAttendees(1, 2)
                } else {
                  // 判断原来是不是存在图片，存在替换了的话要删除之前的图片
                  if (this.form.photo) {
                    // 删除原来的图片
                    $upload('enterpriseImage', this.form.photo, '', 2)
                  }
                  this.toUploadPic(1, 2)
                }
              } else {
                if (!this.photoFile) {
                  this.oprateAttendees(1, 1)
                } else {
                  // 上传了图片
                  this.toUploadPic(1, 1)
                }
              }
              break
            case '2':
              // 2,招聘会企业常用参会人
              if (!this.photoFile) {
                this.oprateAttendees(2, 1)
              } else {
                this.toUploadPic(2, 1)
              }
              break
          }
        }
      })
    }
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
@import "@/assets/css/buttons.scss";
.attendees-dialog {
  .input {
    width: 220px;
  }
  .upload {
    border-radius: 5px;
    width: 100px;
    height: 100px;
    float: left;
    z-index: 1;
    border: 1px dashed #c0ccda;
    text-align: center;
    line-height: 100px;
    vertical-align: middle;
  }
  .buttons {
    text-align: center;
  }
  .image {
    width: 100px;
    height: 100px;
  }
  .remark {
    .flag {
      color: rgb(3, 169, 244);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/enterprise/common/attendees/dialog/attendeesDialog.vue